import { generatePath } from '@toggle/helpers';
import { ThemeSchemaResponse } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { SectionTitle } from '~/components/section-title/SectionTitle';
import { appPaths } from '~/routes/app-paths';
import { queryKeys } from '~/routes/query-params';
import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import * as Shared from '../theme-knowledge-graph/ThemeKnowledgeGraph.styles';

const THEME_COMPETITOR_OVERVIEW = 'overview';

export const CompetingThemes = ({
  competingThemes,
  limit = 3,
}: {
  competingThemes: ThemeSchemaResponse[];
  limit?: number;
}) => {
  const { t } = useTranslation(['widget']);
  const navigate = useNavigate();

  if (!competingThemes.length) {
    return null;
  }

  return (
    <div>
      <SectionTitle
        title={t(
          'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.competingThemes'
        )}
        variant="small"
      />
      <div>
        {competingThemes.slice(0, limit).map((t: ThemeSchemaResponse) => (
          <Shared.ThemeRow
            onClick={() => {
              navigate(
                generatePath({
                  basePath: `${appPaths.themeOverview}/${t.id}`,
                  params: {
                    [queryKeys.activeSubTab]: THEME_COMPETITOR_OVERVIEW,
                  },
                })
              );
            }}
            key={t.name}
          >
            <Shared.ThemeNameWrapper>
              <ThemeLogoIcon
                name={t.name}
                logo_url={t.logo_url}
                fallbackIcon={
                  <Shared.LogoWrapper>{t.name.charAt(0)}</Shared.LogoWrapper>
                }
              />
              <Shared.ThemeName>{t.name}</Shared.ThemeName>
            </Shared.ThemeNameWrapper>
          </Shared.ThemeRow>
        ))}
      </div>
    </div>
  );
};
